import { formatTimestampHuman } from "../date-utils";
export const submissionDtoFields = [{
        name: "challengeName",
        title: "Challenge",
        render: (record) => `<a href="/challenge/${record.challengeId}">${record.challengeName}</a>`
    }, {
        name: "user",
        title: "User",
        render: (record) => record.userLastName + " " + record.userFirstName
    }, {
        name: "userClassroom",
        title: "Classroom",
        render: (record) => record.userClassroom
    }, {
        name: "evaluated",
        title: "Evaluated",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.evaluated === 1 ? "check" : "close"}</i>`
    }, {
        name: "success",
        title: "Compilation",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.success === 1 ? "check" : "close"}</i>`
    }, {
        name: "points",
        title: "Score",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.points + "%"
    }, {
        name: "compiler",
        title: "Compiler",
        render: (record) => record.compiler
    }, {
        name: "createdOn",
        title: "Timestamp",
        render: (record) => formatTimestampHuman(record.createdOn)
    }];
